import { render, staticRenderFns } from "./subprogram-nba-school-card.vue?vue&type=template&id=32d94cf5&scoped=true&"
import script from "./subprogram-nba-school-card.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-school-card.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-school-card.vue?vue&type=style&index=0&id=32d94cf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d94cf5",
  null
  
)

export default component.exports